import service from '../utils/request'

// 获取树形菜单
//export const getMenu = (token) => service.get('/user/menus')
export const getMenu = async () => {
    return service({
        url: '/user/menus',
        method: 'get'
    })
}

export const postRequest = async (url, data) => {
    return service({
        method: 'post',
        url: url,
        data: data,
    })
    .then(response => {
        return response; // 返回接口返回的核心数据
    })
    .catch(error => {
        console.error('POST 请求失败:', error.message);
        throw new Error(`请求 ${url} 失败: ${error.message}`);
    });
};